// Action types
const ActionTypes = {
    SET_CONFIG: 'SET_CONFIG',
  }


function setConfig (payload) {
  return {
    type: ActionTypes.SET_CONFIG,
    payload
  };
}


export {
  ActionTypes,
  setConfig,
};



// WEBPACK FOOTER //
// ./src/js/store/actions/config.js